

























import Vue from "vue";
export default Vue.extend({
  name: "HelpModal",
  methods: {
    close: function(): void {
      this.$emit("close");
    },
   
  }
});
